
export default function TSeriesUtilizationDirective() {
    return {
        restrict: 'E',
        scope: {},
        controller: 'TSeriesUtilizationController',
        template: require('./utilization.html'),
    };
}
